module.exports = __webpack_public_path__ + "static/media/database.7eb3a3b6.svg";